import {
	GET_STTM_ALGORITHM_DATA,
	GET_WEEK,
	// GET_HTML_STRING
} from '../actions/STTMAlgorithmActionsGeneric';

const initialState = {
	data: [],
	week: [],
	// htmlString: '',
	// years: [],
	// months: [],
	// formState: {
	// 	isValid: false,
	// 	values: {
	// 		selectedDatabase: '',
	// 		selectedYear: '',
	// 		selectedMonth: '',
	// 	}
	// },
	// touched: {},
	// errors: {},

};

const STTMAlgorithmReducerGeneric = (state = initialState, action) => {
	switch (action.type) {
					case GET_STTM_ALGORITHM_DATA: {
						return {
							...state,
							data: action.data
						};
					}
					case GET_WEEK: {
						return {
							...state,
							week: action.week
						};
					}
					// case GET_HTML_STRING: {
					// 	return {
					// 		...state,
					// 		htmlString: action.data
					// 	};
					// }

					default: {
						return state;
					}
	}
};

export default STTMAlgorithmReducerGeneric;
